import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import chartOfAccountsApi from '../api/chartOfAccountsApi';
import SearchableSelect from './ui/SearchableSelect';

export default function AccountSelect({
  value,
  onChange,
  label,
  error,
  helperText,
  required = false,
  disabled = false,
  onlyPostable = true,
  ...props
}) {
  const { t } = useTranslation();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    const fetchAccounts = async () => {
      try {
        const response = onlyPostable 
          ? await chartOfAccountsApi.getPostable()
          : await chartOfAccountsApi.getAll();
        
        if (mounted) {
          setAccounts(response.data || []);
        }
      } catch (err) {
        console.error("Error fetching accounts:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchAccounts();

    return () => { mounted = false; };
  }, [onlyPostable]);

  return (
    <SearchableSelect
      label={label || t('selectAccount')}
      options={accounts}
      value={value}
      onChange={onChange}
      loading={loading}
      error={error}
      helperText={helperText}
      disabled={disabled || loading}
      required={required}
      getOptionLabel={(option) => option ? `${option.code} - ${option.nameAr}` : ''}
      getOptionValue={(option) => option?.id}
      {...props}
    />
  );
}
